import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Import_sessions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.import_sessions_Id,
          sortable: true,
          cell: (row) => <span>{row.import_sessions_Id}</span>,
        },
        { name: "Session Code", selector: (row, i) => row.session_code, sortable: true, cell: (row) => <span>{row.session_code}</span>, }, { name: "Session Name", selector: (row, i) => row.session_name, sortable: true, cell: (row) => <span>{row.session_name}</span>, }, { name: "Target Table", selector: (row, i) => row.target_table, sortable: true, cell: (row) => <span>{row.target_table}</span>, }, { name: "File Name", selector: (row, i) => row.file_name, sortable: true, cell: (row) => <span>{row.file_name}</span>, }, { name: "File Path", selector: (row, i) => row.file_path, sortable: true, cell: (row) => <span>{row.file_path}</span>, }, { name: "File Size", selector: (row, i) => row.file_size, sortable: true, cell: (row) => <span>{row.file_size}</span>, }, { name: "File Type", selector: (row, i) => row.file_type, sortable: true, cell: (row) => <span>{row.file_type}</span>, }, { name: "Mapping Config", selector: (row, i) => row.mapping_config, sortable: true, cell: (row) => <span>{row.mapping_config}</span>, }, { name: "Duplicate Check Fields", selector: (row, i) => row.duplicate_check_fields, sortable: true, cell: (row) => <span>{row.duplicate_check_fields}</span>, }, { name: "Total Rows", selector: (row, i) => row.total_rows, sortable: true, cell: (row) => <span>{row.total_rows}</span>, }, { name: "Processed Rows", selector: (row, i) => row.processed_rows, sortable: true, cell: (row) => <span>{row.processed_rows}</span>, }, { name: "Success Count", selector: (row, i) => row.success_count, sortable: true, cell: (row) => <span>{row.success_count}</span>, }, { name: "Update Count", selector: (row, i) => row.update_count, sortable: true, cell: (row) => <span>{row.update_count}</span>, }, { name: "Insert Count", selector: (row, i) => row.insert_count, sortable: true, cell: (row) => <span>{row.insert_count}</span>, }, { name: "Failed Count", selector: (row, i) => row.failed_count, sortable: true, cell: (row) => <span>{row.failed_count}</span>, }, { name: "Skip Count", selector: (row, i) => row.skip_count, sortable: true, cell: (row) => <span>{row.skip_count}</span>, }, { name: "Status", selector: (row, i) => row.status, sortable: true, cell: (row) => <span>{row.status}</span>, }, { name: "Start Time", selector: (row, i) => row.start_time, sortable: true, cell: (row) => <span>{row.start_time}</span>, }, { name: "End Time", selector: (row, i) => row.end_time, sortable: true, cell: (row) => <span>{row.end_time}</span>, }, { name: "Result File Path", selector: (row, i) => row.result_file_path, sortable: true, cell: (row) => <span>{row.result_file_path}</span>, }, { name: "Error Summary", selector: (row, i) => row.error_summary, sortable: true, cell: (row) => <span>{row.error_summary}</span>, },

        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Import_sessionseditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      import_sessions_Id: "",
      session_code: '', session_name: '', target_table: '', file_name: '', file_path: '', file_size: '', file_type: '', mapping_config: '', duplicate_check_fields: '', total_rows: '', processed_rows: '', success_count: '', update_count: '', insert_count: '', failed_count: '', skip_count: '', bulkimportstatusmaster: [], status: '', start_time: '', end_time: '', result_file_path: '', error_summary: '',

    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'session_code', inputType: 'Text', displayName: 'Session Code', validationOptions: { isRequired: false } },
      { fieldName: 'session_name', inputType: 'Text', displayName: 'Session Name', validationOptions: { isRequired: false } },
      { fieldName: 'target_table', inputType: 'Text', displayName: 'Target Table', validationOptions: { isRequired: false } },
      { fieldName: 'file_name', inputType: 'Text', displayName: 'File Name', validationOptions: { isRequired: false } },
      { fieldName: 'file_path', inputType: 'Text', displayName: 'File Path', validationOptions: { isRequired: false } },
      { fieldName: 'file_size', inputType: 'Number', displayName: 'File Size', validationOptions: { isRequired: false } },
      { fieldName: 'file_type', inputType: 'Text', displayName: 'File Type', validationOptions: { isRequired: false } },
      { fieldName: 'mapping_config', inputType: 'Text', displayName: 'Mapping Config', validationOptions: { isRequired: false } },
      { fieldName: 'duplicate_check_fields', inputType: 'Text', displayName: 'Duplicate Check Fields', validationOptions: { isRequired: false } },
      { fieldName: 'total_rows', inputType: 'Number', displayName: 'Total Rows', validationOptions: { isRequired: false } },
      { fieldName: 'processed_rows', inputType: 'Number', displayName: 'Processed Rows', validationOptions: { isRequired: false } },
      { fieldName: 'success_count', inputType: 'Number', displayName: 'Success Count', validationOptions: { isRequired: false } },
      { fieldName: 'update_count', inputType: 'Number', displayName: 'Update Count', validationOptions: { isRequired: false } },
      { fieldName: 'insert_count', inputType: 'Number', displayName: 'Insert Count', validationOptions: { isRequired: false } },
      { fieldName: 'failed_count', inputType: 'Number', displayName: 'Failed Count', validationOptions: { isRequired: false } },
      { fieldName: 'skip_count', inputType: 'Number', displayName: 'Skip Count', validationOptions: { isRequired: false } },
      { fieldName: 'status', inputType: 'Select', displayName: 'Status', validationOptions: { isRequired: false } },
      { fieldName: 'start_time', inputType: 'Date', displayName: 'Start Time', validationOptions: { isRequired: false } },
      { fieldName: 'end_time', inputType: 'Date', displayName: 'End Time', validationOptions: { isRequired: false } },
      { fieldName: 'result_file_path', inputType: 'Text', displayName: 'Result File Path', validationOptions: { isRequired: false } },
      { fieldName: 'error_summary', inputType: 'Text', displayName: 'Error Summary', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      session_code: '', session_name: '', target_table: '', file_name: '', file_path: '', file_size: '', file_type: '', mapping_config: '', duplicate_check_fields: '', total_rows: '', processed_rows: '', success_count: '', update_count: '', insert_count: '', failed_count: '', skip_count: '', bulkimportstatusmaster: [], status: '', start_time: '', end_time: '', result_file_path: '', error_summary: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      session_code: '', session_name: '', target_table: '', file_name: '', file_path: '', file_size: '', file_type: '', mapping_config: '', duplicate_check_fields: '', total_rows: '', processed_rows: '', success_count: '', update_count: '', insert_count: '', failed_count: '', skip_count: '', bulkimportstatusmaster: [], status: '', start_time: '', end_time: '', result_file_path: '', error_summary: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Import_sessionseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      import_sessions_Id: row.import_sessions_Id,
      session_code: row.session_code, session_name: row.session_name, target_table: row.target_table, file_name: row.file_name, file_path: row.file_path, file_size: row.file_size, file_type: row.file_type, mapping_config: row.mapping_config, duplicate_check_fields: row.duplicate_check_fields, total_rows: row.total_rows, processed_rows: row.processed_rows, success_count: row.success_count, update_count: row.update_count, insert_count: row.insert_count, failed_count: row.failed_count, skip_count: row.skip_count, bulkimportstatusmaster: [], status: row.status, start_time: row.start_time, end_time: row.end_time, result_file_path: row.result_file_path, error_summary: row.error_summary,

      errors: {},
      touched: {}
    });
  }

  Import_sessionsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Import_sessions/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  Import_sessionssubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('session_code', this.state.session_code);
    formData.append('session_name', this.state.session_name);
    formData.append('target_table', this.state.target_table);
    formData.append('file_name', this.state.file_name);
    formData.append('file_path', this.state.file_path);
    formData.append('file_size', this.state.file_size);
    formData.append('file_type', this.state.file_type);
    formData.append('mapping_config', this.state.mapping_config);
    formData.append('duplicate_check_fields', this.state.duplicate_check_fields);
    formData.append('total_rows', this.state.total_rows);
    formData.append('processed_rows', this.state.processed_rows);
    formData.append('success_count', this.state.success_count);
    formData.append('update_count', this.state.update_count);
    formData.append('insert_count', this.state.insert_count);
    formData.append('failed_count', this.state.failed_count);
    formData.append('skip_count', this.state.skip_count);
    formData.append('status', this.state.status);
    formData.append('start_time', this.state.start_time);
    formData.append('end_time', this.state.end_time);
    formData.append('result_file_path', this.state.result_file_path);
    formData.append('error_summary', this.state.error_summary);



    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Import_sessions/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Import_sessionsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ session_code: '', session_name: '', target_table: '', file_name: '', file_path: '', file_size: '', file_type: '', mapping_config: '', duplicate_check_fields: '', total_rows: '', processed_rows: '', success_count: '', update_count: '', insert_count: '', failed_count: '', skip_count: '', bulkimportstatusmaster: [], status: '', start_time: '', end_time: '', result_file_path: '', error_summary: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  Import_sessionsupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("import_sessions_Id", this.state.import_sessions_Id);
    formData.append('session_code', this.state.session_code);
    formData.append('session_name', this.state.session_name);
    formData.append('target_table', this.state.target_table);
    formData.append('file_name', this.state.file_name);
    formData.append('file_path', this.state.file_path);
    formData.append('file_size', this.state.file_size);
    formData.append('file_type', this.state.file_type);
    formData.append('mapping_config', this.state.mapping_config);
    formData.append('duplicate_check_fields', this.state.duplicate_check_fields);
    formData.append('total_rows', this.state.total_rows);
    formData.append('processed_rows', this.state.processed_rows);
    formData.append('success_count', this.state.success_count);
    formData.append('update_count', this.state.update_count);
    formData.append('insert_count', this.state.insert_count);
    formData.append('failed_count', this.state.failed_count);
    formData.append('skip_count', this.state.skip_count);
    formData.append('status', this.state.status);
    formData.append('start_time', this.state.start_time);
    formData.append('end_time', this.state.end_time);
    formData.append('result_file_path', this.state.result_file_path);
    formData.append('error_summary', this.state.error_summary);



    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Import_sessions/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Import_sessionsfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.Import_sessionsfetchHandler();
    this.bulkimportstatusmasterfetchHandler();


  }

  handlesession_codeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ session_code: fieldValue });
  }; handlesession_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ session_name: fieldValue });
  }; handletarget_tableChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ target_table: fieldValue });
  }; handlefile_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ file_name: fieldValue });
  }; handlefile_pathChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ file_path: fieldValue });
  }; handlefile_sizeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ file_size: fieldValue });
  }; handlefile_typeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ file_type: fieldValue });
  }; handlemapping_configChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ mapping_config: fieldValue });
  }; handleduplicate_check_fieldsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ duplicate_check_fields: fieldValue });
  }; handletotal_rowsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ total_rows: fieldValue });
  }; handleprocessed_rowsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ processed_rows: fieldValue });
  }; handlesuccess_countChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ success_count: fieldValue });
  }; handleupdate_countChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ update_count: fieldValue });
  }; handleinsert_countChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ insert_count: fieldValue });
  }; handlefailed_countChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ failed_count: fieldValue });
  }; handleskip_countChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ skip_count: fieldValue });
  }; handlestatusChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ status: fieldValue });
  }; bulkimportstatusmasterfetchHandler = () => {
    fetch(configData.api_url + "C_Bulkimportstatusmaster/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ bulkimportstatusmaster: data.list });
        }
      });
  }; handlestart_timeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ start_time: fieldValue });
  }; handleend_timeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ end_time: fieldValue });
  }; handleresult_file_pathChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ result_file_path: fieldValue });
  }; handleerror_summaryChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ error_summary: fieldValue });
  };


  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this import_sessions?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('import_sessions_Id', row.import_sessions_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Import_sessions/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Import_sessionsfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Import Sessions</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Import_sessions</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Session Code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlesession_codeChange} className="form-control" name="session_code" value={this.state.session_code} required="required" placeholder="Enter session_code" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.session_code} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Session Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlesession_nameChange} className="form-control" name="session_name" value={this.state.session_name} required="required" placeholder="Enter session_name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.session_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Target Table</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletarget_tableChange} className="form-control" name="target_table" value={this.state.target_table} required="required" placeholder="Enter target_table" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.target_table} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>File Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlefile_nameChange} className="form-control" name="file_name" value={this.state.file_name} required="required" placeholder="Enter file_name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.file_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>File Path</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlefile_pathChange} className="form-control" name="file_path" value={this.state.file_path} required="required" placeholder="Enter file_path" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.file_path} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>File Size</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlefile_sizeChange} className="form-control" name="file_size" value={this.state.file_size} required="required" placeholder="Enter file_size" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.file_size} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>File Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlefile_typeChange} className="form-control" name="file_type" value={this.state.file_type} required="required" placeholder="Enter file_type" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.file_type} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Mapping Config</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlemapping_configChange} className="form-control" name="mapping_config" value={this.state.mapping_config} required="required" placeholder="Enter mapping_config" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.mapping_config} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Duplicate Check Fields</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleduplicate_check_fieldsChange} className="form-control" name="duplicate_check_fields" value={this.state.duplicate_check_fields} required="required" placeholder="Enter duplicate_check_fields" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.duplicate_check_fields} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Total Rows</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handletotal_rowsChange} className="form-control" name="total_rows" value={this.state.total_rows} required="required" placeholder="Enter total_rows" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.total_rows} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Processed Rows</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleprocessed_rowsChange} className="form-control" name="processed_rows" value={this.state.processed_rows} required="required" placeholder="Enter processed_rows" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.processed_rows} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Success Count</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlesuccess_countChange} className="form-control" name="success_count" value={this.state.success_count} required="required" placeholder="Enter success_count" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.success_count} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Update Count</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleupdate_countChange} className="form-control" name="update_count" value={this.state.update_count} required="required" placeholder="Enter update_count" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.update_count} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Insert Count</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleinsert_countChange} className="form-control" name="insert_count" value={this.state.insert_count} required="required" placeholder="Enter insert_count" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.insert_count} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Failed Count</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlefailed_countChange} className="form-control" name="failed_count" value={this.state.failed_count} required="required" placeholder="Enter failed_count" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.failed_count} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Skip Count</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleskip_countChange} className="form-control" name="skip_count" value={this.state.skip_count} required="required" placeholder="Enter skip_count" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.skip_count} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handlestatusChange}>
                                        <option defaultValue> Select Status </option>
                                        {this.state.bulkimportstatusmaster.map((api, index, idx) => (
                                          <option key={index} value={api.uploaded}> {api.uploaded} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.status} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Start Time</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handlestart_timeChange} className="form-control" name="start_time" value={this.state.start_time} required="required" placeholder="Enter start_time" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.start_time} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>End Time</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handleend_timeChange} className="form-control" name="end_time" value={this.state.end_time} required="required" placeholder="Enter end_time" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.end_time} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Result File Path</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleresult_file_pathChange} className="form-control" name="result_file_path" value={this.state.result_file_path} required="required" placeholder="Enter result_file_path" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.result_file_path} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Error Summary</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleerror_summaryChange} className="form-control" name="error_summary" value={this.state.error_summary} required="required" placeholder="Enter error_summary" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.error_summary} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Import_sessionssubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Import_sessions</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Session Code</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlesession_codeChange} className="form-control" name="session_code" value={this.state.session_code} required="required" placeholder="Enter session_code" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.session_code} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Session Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlesession_nameChange} className="form-control" name="session_name" value={this.state.session_name} required="required" placeholder="Enter session_name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.session_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Target Table</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletarget_tableChange} className="form-control" name="target_table" value={this.state.target_table} required="required" placeholder="Enter target_table" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.target_table} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>File Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlefile_nameChange} className="form-control" name="file_name" value={this.state.file_name} required="required" placeholder="Enter file_name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.file_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>File Path</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlefile_pathChange} className="form-control" name="file_path" value={this.state.file_path} required="required" placeholder="Enter file_path" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.file_path} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>File Size</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlefile_sizeChange} className="form-control" name="file_size" value={this.state.file_size} required="required" placeholder="Enter file_size" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.file_size} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>File Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlefile_typeChange} className="form-control" name="file_type" value={this.state.file_type} required="required" placeholder="Enter file_type" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.file_type} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Mapping Config</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlemapping_configChange} className="form-control" name="mapping_config" value={this.state.mapping_config} required="required" placeholder="Enter mapping_config" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.mapping_config} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Duplicate Check Fields</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleduplicate_check_fieldsChange} className="form-control" name="duplicate_check_fields" value={this.state.duplicate_check_fields} required="required" placeholder="Enter duplicate_check_fields" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.duplicate_check_fields} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Total Rows</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handletotal_rowsChange} className="form-control" name="total_rows" value={this.state.total_rows} required="required" placeholder="Enter total_rows" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.total_rows} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Processed Rows</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleprocessed_rowsChange} className="form-control" name="processed_rows" value={this.state.processed_rows} required="required" placeholder="Enter processed_rows" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.processed_rows} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Success Count</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlesuccess_countChange} className="form-control" name="success_count" value={this.state.success_count} required="required" placeholder="Enter success_count" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.success_count} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Update Count</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleupdate_countChange} className="form-control" name="update_count" value={this.state.update_count} required="required" placeholder="Enter update_count" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.update_count} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Insert Count</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleinsert_countChange} className="form-control" name="insert_count" value={this.state.insert_count} required="required" placeholder="Enter insert_count" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.insert_count} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Failed Count</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlefailed_countChange} className="form-control" name="failed_count" value={this.state.failed_count} required="required" placeholder="Enter failed_count" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.failed_count} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Skip Count</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleskip_countChange} className="form-control" name="skip_count" value={this.state.skip_count} required="required" placeholder="Enter skip_count" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.skip_count} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Status</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handlestatusChange}>
                                          <option defaultValue> Select Status </option>
                                          {this.state.bulkimportstatusmaster.map((api, index, idx) => (
                                            <option key={index} value={api.uploaded}> {api.uploaded} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.status} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Start Time</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handlestart_timeChange} className="form-control" name="start_time" value={this.state.start_time} required="required" placeholder="Enter start_time" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.start_time} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>End Time</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handleend_timeChange} className="form-control" name="end_time" value={this.state.end_time} required="required" placeholder="Enter end_time" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.end_time} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Result File Path</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleresult_file_pathChange} className="form-control" name="result_file_path" value={this.state.result_file_path} required="required" placeholder="Enter result_file_path" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.result_file_path} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Error Summary</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleerror_summaryChange} className="form-control" name="error_summary" value={this.state.error_summary} required="required" placeholder="Enter error_summary" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.error_summary} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Import_sessionsupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus"
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}